module.exports = __webpack_public_path__ + "img/google-wallet.e0521632.svg";